import React from "react"

export default function Facebook(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 455.7 455.7"
      {...props}
    >
      <path
        fill="#3a559f"
        d="M0 0v455.7h242.7v-176h-59.3v-71.9h59.3v-60.3A79.5 79.5 0 01322.2 68h62v64.6h-44.4c-14 0-25.2 11.3-25.2 25.3v50H383l-9.5 71.8h-59v176h141.1V0H0z"
      />
    </svg>
  )
}
